/**
 *
 * Absence
 *
 */

import React, { memo, useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

import { useInjectSaga } from "utils/injectSaga";
import { useInjectReducer } from "utils/injectReducer";
import reducer from "./reducer";
import saga from "./saga";

import {
  flushStateAbsence,
  // list
  loadAbsences,
  changeAbsences,
  deleteAbsence,
} from "./actions";

import {
  selectAbsencesLoading,
  selectUpdatedAbsencesLoading,
  selectAbsenceError,
  selectAbsenceDeleteSuccessful,
  makeSelectItemsListFirstElem,
  makeSelectItemsList,
} from "./selectors";

// antd component
import { Layout, Button, Tabs, Col, Row, Tag } from "antd";
const { Content } = Layout;
const { TabPane } = Tabs;

//components
import CustomPageHeader from "components/CustomPageHeader";
import CustomIcons from "components/CustomIcons";
import TableAbsence from "components/Absences/TableAbsence";
import AbsencesCard from "components/Absences/AbsencesCard";
import InfoCard from "components/InfoCard";
import Preloader from "components/Preloader";
import FeatureNotAvailable from "components/FeatureNotAvailable";

// global user
import { withUser } from "engine/Contexts/User.context";

// utils
import { useAuthRole } from "utils/hooks";
import {
  getAbsenceTypeLabel,
  getAbsenceTypeLabelFull,
  getAbsenceStatusLabel,
  getAbsenceReason,
  getAbsenceDuration,
  getAbsenceMainDate,
  getAbsenceStartTime,
  getTypeList
} from "utils/helpers/helper.generateData";

import { ACTIVITY_REASON_OPTIONS, STATUSES_LIST_OPTIONS } from "utils/helpers/helper.constant";
import { sortByKey } from "utils/helpers/helper.general";
import { convertTimeToString, convertDateToString, convertDateToWeekDay } from "utils/moment/moment.utils";


function Absence({
  // main data
  itemsList,
  firstElem,
  absenceData,
  // states
  loadingUpdatedList,
  deleteSuccessful,
  error,
  loading,
  history,
  user,
  // actions
  loadAbsences,
  changeAbsences,
  deleteAbsence,
  flushState,
  //default
  className,
}) {
  useInjectReducer({ key: "absence", reducer });
  useInjectSaga({ key: "absence", saga });

  const { t, i18n } = useTranslation();

  const newKey = "new";

  const [absences, setAbsences] = useState([]);

  const [activeBtn, setActiveBtn] = useState(false);
  const [activeTab, setActiveTab] = useState("need-action");

  const [finished, setFinished] = useState([]);
  const [dataNoProcessed, setDataNoProcessed] = useState([]);
  const [allSelectedItem, setAllSelectedItem] = useState([]);

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {
    !itemsList && loadAbsences();

    return () => {
      // Clearing the state after unmounting a component
      // Anything in here is fired on component unmount.
      flushState();
    };
  }, []);

  useEffect(() => {
    if (itemsList) {
      
      // TODO: -- Move it to backend
      const newData = itemsList?.data?.map(list => {
        const { children, ...restList } = list;

        // INFO: be cereful with this, it's can call issues with filtering/sorting on the table!
        return ({
          ...restList,
          student: !!list?.student && {
            ...list?.student,
            description: {
              ...list?.student?.description,
              fullname: !!list?.student?.description ? `${list?.student?.description?.lastname} ${list?.student?.description?.firstname}` : ""
            },
          },
          proof: !!list?.media && list?.media?.length > 0 ? t("absences.proofInclude")?.toLocaleLowerCase() : t("absences.proofNoInclude")?.toLocaleLowerCase(),
          duration: !!list?.timeDuration ? getAbsenceDuration(list) : list?.timeDuration,
          modification_date: !!list?.modificationDateByUser ? (
            `${convertDateToString(list?.modificationDateByUser)}, ${convertTimeToString(list?.modificationDateByUser)}`
          ) : list?.modificationDateByUser,
          date_from_format: !!list?.date_from ? (
            `${convertDateToWeekDay(getAbsenceMainDate(list), "dd",)}, ${convertDateToString(getAbsenceMainDate(list))}, ${convertTimeToString(getAbsenceStartTime(list))}`
          ) : list?.date_from,
        });

      }) || [];

      let newList = newData;

      // combine absences with children
      /*    let newList = [];
        for (const abs of newData) {
        if (!!abs?.original) {
          const { children, ...restAbs } = abs;
          newList.push(restAbs);
        } else if (!!abs?.origin) {
          newList = newList?.map(el => {
            if (getObjId(abs?.origin) == getObjId(el) && abs?.status == el?.status) {
              const ch = el?.children || [];
              return {
                ...el,
                children: [
                  ...ch,
                  abs
                ]
              }
            } else {
              return el
            }
          })
        } else {
          newList.push(abs);
        }
      }
 */

      const finishedList = newList.filter(abs => {
        if (
          abs?.status == "accepted" ||
          abs?.status == "sickness-finish" ||
          abs?.status == "refused"
        ) {
          return abs;
        }
      });

      setFinished(finishedList);
      const otherList = newList.filter(abs => !finishedList.includes(abs));
      setDataNoProcessed(otherList);
      user.setAmountAbsence(otherList.length);
      setAbsences([...newList]);
    }
  }, [loading, i18n?.language]);

  const handelClickCreateAbsence = () => {
    history.push(`/absences/${newKey}`);
  };

  const allSelectedItemUpd = (selectedRows, selected) => {
    // console.log({selectedRows})
    setAllSelectedItem(selectedRows);
    setActiveBtn(selected);
  };

  const changeTab = key => {
    setActiveTab(key);
    setActiveBtn(false);
  };

  const setApproveSelection = () => {
    const dataFiltered = dataNoProcessed.filter(
      el => !allSelectedItem.includes(el) || el?.type == "unjustified",
    );

    setDataNoProcessed(dataFiltered);
    user.setAmountAbsence(dataFiltered.length);
    setFinished([...finished, ...allSelectedItem]);

    //action which will update data in database
    const prepeareList = allSelectedItem
      .map(selectedAbs => {
        let absObj = { ...selectedAbs };
        if (selectedAbs?.type == "sickness") {
          absObj.status = "sickness-finish";
        } else if (selectedAbs?.type != "unjustified") {
          absObj.status = "accepted";
        }
        return absObj;
      })?.filter(el => !!el);
    prepeareList && changeAbsences(prepeareList);
    setActiveBtn(false);
  };

  const getStatuses = useCallback(() => STATUSES_LIST_OPTIONS(), [i18n?.language]);
  const getActivityReasons = useCallback(() => ACTIVITY_REASON_OPTIONS(), [i18n?.language]);
  const getAbsenceStatus = useCallback((type) => getAbsenceStatusLabel(type), [i18n?.language]);
  const getAbsenceTypeText = useCallback((text) => {
    return (text == "sickness" || text == "unjustified" ? (
      <span className="title abs-type">
        {getAbsenceTypeLabel(text)}
      </span>
    ) : (
      <span className="title abs-type">
        {getAbsenceTypeLabelFull(text)}
      </span>
    ));
  }, [i18n?.language]);

  //data for columns
  //for columns Motif, Justificatif, Status testing data
  const columns = [
    {
      title: (
        <span className="column-title">
          <CustomIcons type="academic" className="icon-columns student" />
          {t("labels.student")}
        </span>
      ),
      dataIndex: ["student", "description", "fullname"],
      key: "fullname",
      render: (text, record, index) => (
        <strong
          onClick={() => history.push(`/absences/${record.student?._id}`)}
        >
          {text}
        </strong>
      ),
      renderHighlight: (text, record, children) => (
        <strong
          onClick={() => history.push(`/absences/${record.student?._id}`)}
        >
          {children}
        </strong>
      ),
      search: true,
      ellipsis: true,
      sorter: (a, b) =>
        a?.student?.description?.fullname?.localeCompare(
          b?.student?.description?.fullname,
        ),
    },
    {
      title: (
        <span className="column-title">
          <CustomIcons type="users" className="icon-columns student" />
          {t("labels.class")}
        </span>
      ),
      dataIndex: ["student", "class_info", "title"],
      key: "class_title",
      render: (text, record, index) => text,
      renderHighlight: (text, record, children) => children,
      search: true,
      ellipsis: true,
      sorter: (a, b) =>
        !!a?.student?.class_info?.title &&
        a?.student?.class_info?.title?.localeCompare(
          b?.student?.class_info?.title,
        ),
    },
    {
      title: (
        <span className="column-title">
          <CustomIcons type="quil" className="icon-columns type" />
          {t("labels.type")}
        </span>
      ),
      dataIndex: "type",
      key: "type",
      render: (text, record, index) => (
        <>
          {getAbsenceTypeText(text)}

          {(!!record?.origin ||
            !!record?.original ||
            !!record?.unjustified) && (
            <span className="tags-abs">
              {!!record?.original && (
                <Tag className="abs-tag original">
                  {t("absences.recurring")}
                </Tag>
              )}
              {!!record?.origin && (
                <Tag className="abs-tag origin">
                  {t("absences.reccurence")}
                </Tag>
              )}
              {!!record?.unjustified && (
                <Tag className="abs-tag unjustified">
                  {t("global.absenceTypes.unjustified")}
                </Tag>
              )}
            </span>
          )}
        </>
      ),
      filters: getTypeList().map(type => ({
        value: type.value,
        text: type.label,
      })),
      onFilter: (value, record) => record.type == value,
    },
    {
      title: (
        <span className="column-title">
          <CustomIcons type="quil" className="icon-columns reason" />
          {t("absences.reason")}
        </span>
      ),
      dataIndex: "reason",
      key: "reason",
      render: (text, record, index) => (
        <>
          <span className="reason abs-type">{getAbsenceReason(record)}</span>
        </>
      ),
      filters: getActivityReasons()?.map(reason => ({
        value: reason.value,
        text: reason.label,
      })).sort(sortByKey("label")),
      onFilter: (value, record) => record.reason == value,
    },
    {
      title: (
        <span className="column-title">
          <CustomIcons type="calendar" className="icon-columns date" />
          {t("inputs.dateTime")}
        </span>
      ),
      dataIndex: "date_from_format",
      key: "date_from_format",
      search: true,
      ellipsis: true,
      renderHighlight: (text, record, children) => children,
      render: (text, record, index) => {
        return (
          <>
            <span className="column-title">{record?.date_from_format}</span>
          </>
        );
      },
      sorter: (a, b) => {
        const newA = new Date(getAbsenceMainDate(a));
        const newB = new Date(getAbsenceMainDate(b));

        if (newA < newB) return -1;

        if (newA > newB) return 1;

        return 0;
      },
    },
    {
      title: (
        <span className="column-title">
          <CustomIcons type="time" className="icon-columns duration" />
          {t("absences.duration")}
        </span>
      ),
      dataIndex: "duration",
      key: "duration",
      search: true,
      renderHighlight: (text, record, children) => children,
      render: (text, record, index) => (
        <>
          {!!record?.timeDuration && (
            <>
              <CustomIcons type="time" className="icon-columns duration" />
              {record?.duration}
            </>
          )}
        </>
      ),
      sorter: (a, b) => {
        const newA = !!a?.timeDuration ? a?.timeDuration : 0;
        const newB = !!b?.timeDuration ? b?.timeDuration : 0;

        if (newA < newB) return -1;

        if (newA > newB) return 1;

        return 0;
      },
    },
    {
      title: (
        <span className="column-title">
          <CustomIcons type="calendar" className="icon-columns date" />
          {t("common.lastModification")}
        </span>
      ),
      dataIndex: "modification_date",
      key: "modification_date",
      className: "column-modification_date",
      search: true,
      ellipsis: true,
      renderHighlight: (text, record, children) => children,
      render: (text, record, index) => (
        <>
          {!!record?.modificationDateByUser && (
            <>
              <span className="column-title">
                {record?.modification_date}
              </span>
            </>
          )}
        </>
      ),
      sorter: (a, b) => {
        const newA = new Date(a?.modificationDateByUser);
        const newB = new Date(b?.modificationDateByUser);

        if (newA < newB) return -1;

        if (newA > newB) return 1;

        return 0;
      },
    },
    {
      title: (
        <span className="column-title">
          <CustomIcons type="document" className="icon-columns proof" />
          {t("absences.proof")}
        </span>
      ),
      dataIndex: "proof",
      key: "proof",
      search: true,
      ellipsis: true,
      renderHighlight: (text, record, children) => children,
      filters: [
        {
          value: t("absences.proofInclude")?.toLocaleLowerCase(),
          text: t("absences.proofInclude")?.toLocaleLowerCase(),
        },
        {
          value: t("absences.proofNoInclude")?.toLocaleLowerCase(),
          text: t("absences.proofNoInclude")?.toLocaleLowerCase(),
        },
      ],
      onFilter: (value, record) => {
        if (value == t("absences.proofInclude")?.toLocaleLowerCase()) {
          return record?.media && record?.media.length > 0;
        } else {
          return record?.media && record?.media.length == 0;
        }
      },
      render: (text, record, index) => {
        return (
          <span className={`proof${(!record?.media || record?.media?.length == 0) ? " empty" :""}`}>
            {record?.proof}
          </span>
        );
      },
    },
    {
      title: (
        <span className="column-title">
          <CustomIcons type="absence" className="icon-columns status" />
          {t("common.status")}
        </span>
      ),
      dataIndex: "status",
      key: "status",
      render: (text, record, index) => (
        <>
          <span className={`label-tag label-tag--${record?.status}`}>
            {getAbsenceStatus(record?.status)}
          </span>
        </>
      ),
      // !NOTE sorry for below code but coudn't know how to seperate it.
      filters: getStatuses().filter(status =>
        activeTab == "need-action"
          ? !(
              status.value == "accepted" ||
              status.value == "sickness-finish" ||
              status.value == "refused"
            )
          : status.value == "accepted" ||
            status.value == "sickness-finish" ||
            status.value == "refused",
      ).map(status => ({
        value: status.value,
        text: status.label,
      })),
      onFilter: (value, record) => record.status == value,
    },
  ];

  // render function
  return (
    <Layout className="main-full-content">
      <Helmet>
        <title>{t("labels.absences")}</title>
        <meta name="description" content="Description of Absence" />
      </Helmet>
      <Content className="main-content-container absence-wrapper">
        <CustomPageHeader
          className="absence-header"
          title={t("labels.absences")}
          subTitle={""}
          subTitlePosition="top"
          extraActions={[
            <Button
              loading={loading}
              className="box-new-create-btn"
              icon={<CustomIcons type="absence" />}
              onClick={handelClickCreateAbsence}
            >
              {t("absences.newRequest")}
            </Button>,
          ]}
        />

        <Row gutter={(15, 15)} className="absence-row">
          <Col sm={24} md={24} lg={12} xl={12}>
            <InfoCard title={t("absences.absencesToProcess")}>
              {dataNoProcessed?.length || 0}
            </InfoCard>
          </Col>
          {!!useAuthRole(["admin"]) && (
            <Col sm={24} md={24} lg={12} xl={12}>
              <FeatureNotAvailable margin={"0px 7px 15px 7px"}>
                <AbsencesCard absences={absences}>
                  {dataNoProcessed?.length || 0}
                </AbsencesCard>
              </FeatureNotAvailable>
            </Col>
          )}
        </Row>

        {loading && <Preloader />}
        {!loading && (
          <div className="absence-wrapper__content">
            {absences.length > 0 ? (
              <Button
                className={`tabs-approve-choice ${activeBtn ? "active" : ""}`}
                disabled={!activeBtn}
                onClick={setApproveSelection}
              >
                {t("inputs.approveSelection")}
              </Button>
            ) : null}

            <Tabs
              className="absences-tabs"
              defaultActiveKey="need-action"
              activeKey={activeTab}
              onChange={changeTab}
            >
              <TabPane
                className={`tabs-btn`}
                tab={`${t("absences.absencesToProcess")} (${
                  dataNoProcessed.length
                })`}
                key="need-action"
              >
                <TableAbsence
                  dataSource={dataNoProcessed}
                  dataColumns={columns}
                  activeTab={activeTab}
                  createAbsenceAction={handelClickCreateAbsence}
                  openFinishedAbsence={() => changeTab("finished")}
                  allSelectedItemUpd={allSelectedItemUpd}
                  showSorterTooltip={false} // Set this to false to disable the tooltip
                  getCheckboxProps={record => ({
                    disabled: record?.type == "unjustified",
                  })}
                />
              </TabPane>
              <TabPane
                className={`tabs-btn`}
                tab={t("absences.procesedAbsences")}
                key="finished"
              >
                <TableAbsence
                  dataSource={finished}
                  dataColumns={columns}
                  activeTab={activeTab}
                  createAbsenceAction={handelClickCreateAbsence}
                  allSelectedItemUpd={allSelectedItemUpd}
                />
              </TabPane>
            </Tabs>
          </div>
        )}
      </Content>
    </Layout>
  );
}

Absence.defaultProps = {
  loading: false,
};
Absence.propTypes = {
  dispatch: PropTypes.func.isRequired,
  flushState: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  loading: selectAbsencesLoading(),
  loadingUpdatedList: selectUpdatedAbsencesLoading(),
  error: selectAbsenceError(),
  deleteSuccessful: selectAbsenceDeleteSuccessful(),
  itemsList: makeSelectItemsList(),
  firstElem: makeSelectItemsListFirstElem(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    flushState: () => dispatch(flushStateAbsence()),
    loadAbsences: () => dispatch(loadAbsences()),
    changeAbsences: list => dispatch(changeAbsences(list)),
    deleteAbsence: id => dispatch(deleteAbsence(id)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
  withUser,
)(Absence);
